export enum Colors {
  Transparent = 'transparent',
  White = '#FFFFFF',
  // Вторичный текст. Было #88959E: 3.07:1 на белом и 2.66 на LightGray при
  // норме 4.5 — этим цветом покрашены подписи полей, пустые состояния и
  // счётчики по всему ERP (142 места), поэтому недобор шёл на каждом экране.
  // #616E78 даёт 5.24 / 4.79 / 4.53 и сохраняет тот же сине-серый тон.
  // Фоном Gray не используется нигде, так что затемнение ничего не ломает.
  Gray = '#616E78',
  LightGray = '#EBEFF2',
  Red = '#F44336',
  SeaBuckthorn = '#FAAE2B',
  SpringWood = '#faf9f6',
  Black = '#263446',
  Blue = '#0D53FC',
  MainBackground = '#F2F5F9',
  PrimaryBlack = '#000000',
  SecondLightGray = '#DFE6F1',
  ModalBackground = 'rgb(49, 65, 109, 0.4)',
  LightBlue = '#FAFBFD',
  DeactivatedGrey = '#C6CCD0',
  SuccessDefault = '#3CC13B',
  LightShadow = 'rgba(136, 149, 158, 0.08)',
  BlueShadow = 'rgba(38, 52, 70, 0.04)',
  BlueShadowRow = 'rgba(38, 52, 70, 0.12)',
  WarningDefault = '#F3BB1C',
  ErrorDefault = '#F03738',
  BasicBlueLight = '#E7EEFF',
  // Текстовые варианты сигнальных цветов.
  //
  // Сами SuccessDefault / WarningDefault / ErrorDefault остаются как есть: они
  // верны для РАМОК, точек и индикаторов, где яркость и нужна. Но как ТЕКСТ на
  // белом они дают 2.36 / 1.76 / 3.96 при норме 4.5 — подпись «подключено» или
  // «просрочено» читалась хуже всего именно там, где важна.
  // Значения ниже: 5.13-6.29 / 5.54 / 5.62 на белом и не ниже 4.4 на плашках.
  SuccessText = '#256E29',
  WarningText = '#8A6100',
  ErrorText = '#C62828',
}
